import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportsService } from '../reports.service';
import { MatTableDataSource } from '@angular/material/table';
import { IReportModel } from '../reports.model';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject, startWith, distinctUntilChanged, debounceTime, map } from 'rxjs';
import { Router } from '@angular/router';
import { MimeExtensionClass } from '../../../models/global-models/mime-extension';
import { SendEmailConfirmationComponent } from '../../dialog-box/send-email-confirmation/send-email-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiRelativeRoutes, ApiRoutes } from 'src/app/services/apiroutes';
import { FailureBoxComponent } from '../../dialog-box/failure-box/failure-box.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DownloadService } from 'src/app/pages/dashboards/arcon-dashboard/download.service';

@Component({
    selector: 'logzy-reports-table',
    templateUrl: './reports-table.component.html',
    styleUrls: ['./reports-table.component.scss', '../../verify-customer/lead-table/lead-table.component.scss']
})
export class ReportsTableComponent implements OnInit {
    @Input()
    refreshTable = new BehaviorSubject(null);

    @Input()
    downloadButtons: boolean = true;

    @Input()
    pageName: string = 'container_master';

    @Output()
    openNewReportSidePanel = new EventEmitter();

    @Output()
    openLogsSidePanel = new EventEmitter();

    @Output()
    menuLength = new EventEmitter();

    searchTerm = '';
    searchText = new BehaviorSubject<string>(null);
    reportList: MatTableDataSource<IReportModel>;
    reportListForPage: IReportModel[] = [];
    updateReportList: boolean = false;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    loading: boolean = true;
    disableSendButton;
    displayColumns = ['name', 'description', 'actions'];

    mimeExt = new MimeExtensionClass();
    isDownload: boolean = true;    
    Canvas: string = "Canvas";
    @Output() canvas = new EventEmitter<string>();

    constructor(private reportService: ReportsService,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private downloadService: DownloadService,

    ) { }

    ngOnInit(): void {
        this.resetComponent();

        this.refreshTable.subscribe(item => {
            if (item) {
                this.getReportList();
            } else {
                return;
            }
        })
    }

    resetComponent() {
        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                if (searchText == '') {
                    this.getReportList();
                } else {
                    this.getReportList(searchText, this.pageSize, this.pageIndex)
                }
            })
        ).subscribe();
    }

    getReportList(searchTerm = null, pageSize = null, pageIndex = null, ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;

        this.reportService.getReportList(searchTerm, pageSize, pageIndex + 1, ordering).subscribe({
            next: res => {
                this.reportList = new MatTableDataSource(res.results);
                this.getListForSpecificPage();
                this.pageLength = res.count;
                this.loading = false;
                this.updateReportList = false;
            },
            error: err => {
                console.log(err);
            }
        });
    }

    applyFilter(event) {
        this.searchTerm = event;
        this.updateReportList = true;
        this.searchText.next(event);
    }

    announceSortChange(sortState: Sort) {
        this.updateReportList = true;
        switch (sortState.direction) {
            case 'asc':
                this.getReportList(this.searchTerm, this.pageSize, this.pageIndex, sortState.active);
                break;

            case 'desc':
                this.getReportList(this.searchTerm, this.pageSize, this.pageIndex, `-${sortState.active}`);
                break;

            default:
                this.getReportList(this.searchTerm, this.pageSize, this.pageIndex, null);
        }
    }

    pageChanged(event: PageEvent) {
        this.updateReportList = true;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.getReportList(this.searchTerm)
    }

    openSidePanel() {
        this.openNewReportSidePanel.emit(true);
    }

    closeDetails() {
        this.router.navigateByUrl(`dashboards/dashboard1`);
    }

    // downloadPageReport(report) {
    //     this.updateReportList = true;
    //     this.snackBar.open("Downloading.....", 'Close', {
    //         verticalPosition: 'top',
    //         duration: 1000,
    //     });
    //     this.reportService.downloadReportById(report.id).subscribe({
    //         next: res => {
    //             let newBlob = new Blob([res], { type: res.type });

    //             let downloadURL = window.URL.createObjectURL(newBlob);
    //             let link = document.createElement('a');
    //             link.href = downloadURL;
    //             link.download = `${report.name}${this.getExtFromMime(res.type)}`;
    //             link.click();
    //             // this.isDownload = true;
    //             this.updateReportList = false;
    //             this.resetComponent();
    //             return res;
    //         },
    //         error: err => {
    //             if (err.status > 399 && err.status < 500) {
    //                 if (err.error instanceof Blob) {
    //                     this.handleBlobError(err);
    //                 }
    //             } else if (err.status >= 500) {
    //                 this.snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
    //                     verticalPosition: 'top',
    //                     duration: 3000,
    //                 });
    //             }
    //             this.updateReportList = false;
    //             this.resetComponent();
    //             return err;
    //         }
    //     });
    // }

    handleBlobError(error) {
        error.error.text().then((res) => {
            const blobError = JSON.parse(res);
            this.openFailureDialog('', blobError.detail);
        });
    }

    openSendEmailConfirmationDialog(report): void {
        let htmlContent: string = '';
        this.reportService.shareReportById(report.id).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [],
                    userListKey: '',
                    contentURL: `${ApiRoutes.Reports}send_report_mail/${report.id}/`,
                    contentKeys: {
                        to_emails: '',
                        subject: `Sharing: ${report.name}`,
                        content: htmlContent
                    },
                    mailType: 'share_report',
                    snackBarMessage: 'Report shared via email!'
                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    // this.getReportList();
                });
            },
            (error) => {
                if (error.status >= 500) {
                    this.snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                }
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    openFailureDialog(label: string, description, action: string = null) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: action }
        });

        dialogRef.afterClosed().subscribe(item => {

        });
    }

    getExtFromMime(mimeString) {
        for (let i = 0; i < this.mimeExt.mimeExtension.length; i++) {
            if (mimeString == this.mimeExt.mimeExtension[i].mime_type) {
                return this.mimeExt.mimeExtension[i].extension
            }
        }
    }

    getListForSpecificPage() {
        for (let i = 0; i < this.reportList.data.length; i++) {
            for (let j = 0; j < this.reportList.data[i].display_in_menus.length; j++) {
                if (this.pageName == this.reportList.data[i].display_in_menus[j].page_url) {
                    this.reportListForPage.push(this.reportList.data[i]);
                }
            }
        }
        this.menuLength.emit(this.reportListForPage.length);
    }

    viewLogs(data) {
        this.openLogsSidePanel.emit(data);
    }

    downloadPageReport(report: any) {
        let url_endpoint = `${ApiRelativeRoutes.Report}${report.id}/download/`;
        this.downloadService.downloadInNewTab(url_endpoint)
    }
}
